import { ArrowLeft02Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { Button } from "@unfiddle/ui/components/button"
import { Field, FieldControl, FieldLabel } from "@unfiddle/ui/components/field"
import { formData } from "@unfiddle/ui/utils"
import { trpc } from "@/trpc"
import { BackButton } from "@/ui/components/back-button"

export const Route = createFileRoute("/_authed/new")({
   component: RouteComponent,
})

function RouteComponent() {
   const navigate = useNavigate()
   const queryClient = useQueryClient()

   const create = useMutation(
      trpc.workspace.create.mutationOptions({
         onSuccess: (workspaceId) => {
            navigate({
               to: "/$workspaceId",
               params: { workspaceId },
            })
            queryClient.invalidateQueries(
               trpc.workspace.memberships.queryOptions(),
            )
         },
      }),
   )

   return (
      <main
         className={
            "flex h-svh grow flex-col items-center justify-center bg-background"
         }
      >
         <BackButton
            size={"lg"}
            kind={"icon"}
            variant={"ghost"}
            aria-label="Back"
            className="absolute top-3 left-3 md:top-5 md:left-5"
         >
            <HugeiconsIcon icon={ArrowLeft02Icon} />
         </BackButton>
         <form
            onSubmit={async (e) => {
               e.preventDefault()
               const form = formData<{ name: string }>(e.target)

               create.mutate({ name: form.name })
            }}
            className="mx-auto w-full max-w-84 px-5"
         >
            <h1 className="mb-4 text-xl">Створіть проєкт</h1>
            <Field>
               <FieldLabel>Ім'я</FieldLabel>
               <FieldControl
                  autoFocus
                  required
                  name="name"
                  placeholder="Над чим працюєте?"
               />
            </Field>
            <Button
               type="submit"
               pending={create.isPending || create.isSuccess}
               disabled={create.isPending || create.isSuccess}
               size={"lg"}
               className="mt-7 w-full"
            >
               Створити
            </Button>
         </form>
      </main>
   )
}
